import { TemplatePage } from './types';

const imageLowerThirdPage: TemplatePage = {
  header: {
    color: '#DCD7F5',
    icon: 'images/video-templates/lower_third.jpg',
    title: 'Free Lower Third Templates',
    title_meta: 'Free Editable Lower Third Templates',
    description_meta:
      'Provide context and information for what is happening on-screen with Wave.video’s editable lower third templates.',
    description:
      'Add a professional touch to your videos and live streams with our editable lower third templates. ' +
      'Provide context and information for what is happening on-screen without distracting viewers from the main content.'
  },
  footer: {
    type: 'image',
    showCustomizeVideo: false,
    category: 'Lower Third',
    description:
      'With Wave.video’s wide collection of customizable and free lower third templates, you will be able to create memorable ' +
      'images for videos, social media, emails, live streams, and more in a few clicks. No need to clutter up your computer ' +
      'with heavy software and files — you will only need access to the internet and a web browser to succeed in all of your ' +
      'creative endeavors. Just select a template that you prefer and effortlessly customize it to your taste. Reach your ' +
      'marketing goals with Wave.video free lower third templates!'
  },
  content: [
    {
      type: 'templates',
      title: 'Free Lower Third Templates',
      search: {
        category: '/images/lower third'
      }
    }
  ]
};

export default imageLowerThirdPage;
